export default __webpack_public_path__ + "static/lutein-table-mobile-en-8fd0522f9de643f84bd7107a1a9b7592.svg";